import { render, staticRenderFns } from "./CoffeeSize.vue?vue&type=template&id=1bb12358"
import script from "./CoffeeSize.vue?vue&type=script&lang=js"
export * from "./CoffeeSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports